module.exports = __webpack_public_path__ + "img/rabit.13048fbb.gif";